import { render, staticRenderFns } from "./contactEnquiry.vue?vue&type=template&id=52b2f38c&scoped=true&"
import script from "./contactEnquiry.vue?vue&type=script&lang=js&"
export * from "./contactEnquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b2f38c",
  null
  
)

export default component.exports